import { forwardRef, ForwardedRef, useImperativeHandle } from 'react'
import NextLink from 'next/link'
import { Link as ReactScrollLink } from 'react-scroll'
import { Interpolation, Theme } from '@emotion/react'
import { useRouter } from 'next/router'

export type ScrollOption = {
  spy?: boolean
  smooth?: boolean
  hashSpy?: boolean
  duration?: number
  offset?: number
  activeClass?: string
}

export type URL = {
  pathname: string
  hash?: string
}

export type ScrollLinkProps = {
  url: URL
  css?: Interpolation<Theme>
  children?: React.ReactNode
  onClick?: () => void
  scrollOption?: ScrollOption
}

export const SCROLL_OPTION: ScrollOption = {
  spy: false,
  smooth: true,
  hashSpy: true,
  duration: 500,
  offset: -60,
}

function ScrollLink(
  { url, css, scrollOption, ...rest }: ScrollLinkProps,
  ref: ForwardedRef<unknown>,
): React.ReactElement {
  useImperativeHandle(ref, () => ({}))

  const { pathname } = useRouter()

  if (
    (url.pathname === 'currentPath' || url.pathname === pathname) &&
    url.hash
  ) {
    return (
      <ReactScrollLink
        {...SCROLL_OPTION}
        {...scrollOption}
        {...rest}
        to={url.hash}
        href={url.hash === 'top' ? '' : `#${url.hash}`}
      />
    )
  }

  return (
    <NextLink href={url} scroll passHref>
      <a css={css} {...rest} />
    </NextLink>
  )
}

export default forwardRef(ScrollLink)
